export const SectionHeading = ({ eyebrow, title, accent, lead, light = false, align = "center", as: Tag = "h2", id }) => (
  <div className={`${align === "center" ? "text-center mx-auto" : ""} max-w-3xl mb-10 md:mb-14`}>
    {eyebrow && <span className="eyebrow mb-3">{eyebrow}</span>}
    <Tag id={id} className={`section-title ${light ? "text-white" : ""}`}>
      {accent ? <><span className={light ? "gold-text" : "text-emerald"}>{accent}</span> {title}</> : title}
    </Tag>
    <div className={`section-divider my-5 ${align !== "center" ? "mx-0" : ""}`} />
    {lead && <p className={`section-lead ${light ? "text-white/75" : ""}`}>{lead}</p>}
  </div>
);
